'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { useDispatch, useSelector } from 'react-redux';
import Informations from '@/src/components/informations/Informations';
import SocialNetwork from '@/src/components/socialNetwork/SocialNetwork';
import { addByIncrement } from '@/src/store/reducers/cartSlice';
import { listSingleProduct } from '@/src/actions/singleProducts';
import Head from "next/head";
import { useRouter, useParams } from "next/navigation"; // <-- useParams

export default function Product() {
  const [total, setTotal] = useState(1);

const rawParams = useParams();

  const productName = typeof rawParams?.productName === 'string' ? rawParams.productName : '';
  const categoryName = typeof rawParams?.categoryName === 'string' ? rawParams.categoryName : '';



  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const dispatch = useDispatch();

  const singleProductList = useSelector((state) => state.singleProductList);
  const { error1, loading1, singleProduct } = singleProductList;

  useEffect(() => {
    if (productName) {
      dispatch(listSingleProduct(productName));
    }
  }, [dispatch, productName]);

  const getSingleProduct = singleProduct?.result;

  const currentPageurl = typeof window !== 'undefined' ? window.location.href : '';

  const handleAddToCart = (product) => {
    dispatch(addByIncrement({ product: product, cartQuantity: total }));
  };

  const language = useSelector((state) => state.language.language);
  const locationStore = useSelector((state) => state.location.location);

  const text = {
    HomeText: language === 'en' ? 'Home' : 'होम',
    ServiceText: language === 'en' ? 'Service' : 'सेवा',
    InStock: language === 'en' ? 'In Stock' : 'स्टॉक में',
    StockOut: language === 'en' ? 'Stock Out' : 'स्टॉक ख़त्म',
    ButtonLabel: language === 'en' ? 'Add To Cart' : 'कार्ट में जोड़ें',
  };

  const title = getSingleProduct?.parent_data?.seo_title ||
  `${getSingleProduct?.product_name} service at Home | Smooth & Hygienic Service – Door to Door Beauty`;

  const description = getSingleProduct?.parent_data?.seo_description ||
    `Get flawless results with our professional ${getSingleProduct?.product_name} service at home. Hygienic, affordable, and handled by experts. Book now with Door to Door Beauty!`;

  const keywords = (getSingleProduct?.parent_data?.seo_keyword?.length > 2)
    ? getSingleProduct.parent_data.seo_keyword
    : getSingleProduct?.product_name;


  // const currentPageurl = `https://www.doortodoorbeauty.com/service/${categoryName}/${productName}`;

  const ogImage = getSingleProduct?.photo_url || getSingleProduct?.parent_data?.photo_url;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content="Door to Door Beauty" />

        {/* Open Graph */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={currentPageurl} />
        {ogImage && <meta property="og:image" content={ogImage} />}

        {/* Twitter */}
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        {ogImage && <meta name="twitter:image" content={ogImage} />}

        {/* Canonical */}
        <link rel="canonical" href={currentPageurl} />
      </Head>

      <div className="bg-gray-50">
        {getSingleProduct && (
          <div className="px-0 py-10 lg:py-10">
            <div className="mx-auto px-3 lg:px-10 max-w-screen-2xl">
              <div className="flex items-center pb-4">
                <ol className="flex items-center w-full overflow-hidden">
                  <li className="text-sm pr-1 transition duration-200 ease-in cursor-pointer font-semibold">
                    <Link
                      className="!no-underline !text-black hover:!text-emerald-500"
                      href="/"
                    >
                      {text.HomeText}
                    </Link>
                  </li>
                  <li className="text-sm mt-[1px]">
                    <svg
                      stroke="currentColor"
                      fill="none"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </li>
                  <li className="text-sm pr-1 transition duration-200 ease-in cursor-pointer hover:text-emerald-500 font-semibold">
                    <Link
                      className="!no-underline !text-black hover:!text-emerald-500"
                      href={`/services/${getSingleProduct?.parent_data?.slug}/${locationStore}`}
                    >
                      {language === 'en'
                        ? getSingleProduct.parent_data.name
                        : getSingleProduct.parent_data.name_hindi}{' '}
                      {text.ServiceText}
                    </Link>
                  </li>
                  <li className="text-sm mt-[1px]">
                    <svg
                      stroke="currentColor"
                      fill="none"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </li>
                  <li className="text-sm px-1 transition duration-200 ease-in ">
                    {language === 'en'
                      ? getSingleProduct.product_name
                      : getSingleProduct.product_name_hindi}
                  </li>
                </ol>
              </div>
              <div className="w-full rounded-lg p-3 lg:p-12 bg-white">
                <div className="flex flex-col xl:flex-row">
                  <div className="flex-shrink-0 xl:pr-10 lg:block w-full mx-auto md:w-6/12 lg:w-5-12 xl:w-4/12">
                    {getSingleProduct.discount === 0 ? (
                      ''
                    ) : (
                      <span className=" text-dark text-sm bg-orange-500 text-white py-1 px-2 rounded font-medium z-10 right-4 top-4">
                        {Math.ceil(getSingleProduct.discount)}% Off
                      </span>
                    )}
                    <span
                      style={{
                        boxSizing: 'border-box',
                        display: 'block',
                        overflow: 'hidden',
                        width: 'initial',
                        height: 'initial',
                        background: 'none',
                        opacity: '1',
                        border: '0px',
                        margin: '0px',
                        padding: '0px',
                        position: 'relative',
                      }}
                    >
                      <img
                        alt={getSingleProduct.product_name}
                        src={getSingleProduct.photo_url}
                        sizes="100vw"
                      />
                    </span>
                  </div>
                  <div className="w-full">
                    <div className="flex flex-col md:flex-row lg:flex-row xl:flex-row">
                      <div className="w-full md:w-7/12 md:pr-4 lg:pr-4 xl:pr-12">
                        <div className="mb-6">
                          <h1 style={{ fontSize: '22px', lineHeight: '1.2' }} className="font-semibold text-gray-800">
  {language === 'en'
    ? getSingleProduct.product_name
    : getSingleProduct.product_name_hindi}
</h1>
                        </div>
                        <div className="font-bold">
                          <span className="inline-block text-2xl">
                            ₹{getSingleProduct.currentprice}
                          </span>
                          {getSingleProduct.originalPrice ===
                          getSingleProduct.currentprice ? (
                            ''
                          ) : (
                            <del className="text-lg font-normal text-gray-400 ml-1">
                              ₹{getSingleProduct.originalPrice}
                            </del>
                          )}
                        </div>
                        <div className="mb-4 md:mb-5 block">
                          {getSingleProduct.quantity !== 0 && (
                            <span className="bg-emerald-100 text-emerald-600 rounded-full inline-flex items-center justify-center px-2 py-1 text-xs font-semibold mt-2 ">
                              {text.InStock}
                            </span>
                          )}
                          {getSingleProduct.quantity === 0 && (
                            <span className="bg-red-100 text-red-600 rounded-full inline-flex items-center justify-center px-2 py-1 text-xs font-semibold  mt-2">
                              {text.StockOut}
                            </span>
                          )}
                        </div>
                        <div>
                          <p className="text-sm leading-6 text-gray-500 md:leading-7">
                            <span
                              dangerouslySetInnerHTML={{
                                __html:
                                  getSingleProduct &&
                                  (language === 'en'
                                    ? getSingleProduct.description
                                    : getSingleProduct.description_hindi) &&
                                  (language === 'en'
                                    ? getSingleProduct.description
                                    : getSingleProduct.description_hindi)
                                    .length > 605
                                    ? `${
                                        (
                                          language === 'en'
                                            ? getSingleProduct.description
                                            : getSingleProduct.description_hindi
                                        ).substring(0, 605)
                                      }...`
                                    : language === 'en'
                                    ? getSingleProduct.description
                                    : getSingleProduct.description_hindi || '',
                              }}
                            />
                          </p>


                          
                          <div className="flex items-center mt-4">
                            <div className="flex items-center justify-between space-s-3 sm:space-s-4 w-full">
                              <div className="group flex items-center justify-between rounded-md overflow-hidden flex-shrink-0 border h-11 md:h-12 border-gray-300">
                                <button
                                  onClick={() => setTotal(total - 1)}
                                  disabled={total <= 1}
                                  className="flex items-center justify-center flex-shrink-0 h-full transition ease-in-out duration-300 focus:outline-none w-8 md:w-12 text-heading border-e border-gray-300 hover:text-gray-500"
                                >
                                  <span className="text-dark text-base">
                                    <svg
                                      stroke="currentColor"
                                      fill="none"
                                      strokeWidth="2"
                                      viewBox="0 0 24 24"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      height="1em"
                                      width="1em"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <line x1="5" y1="12" x2="19" y2="12"></line>
                                    </svg>
                                  </span>
                                </button>

                                <p className="font-semibold flex items-center justify-center h-full transition-colors duration-250 ease-in-out cursor-default flex-shrink-0 text-base text-heading w-8 md:w-20 xl:w-24">
                                  {total}
                                </p>

                                <button
                                  onClick={() => setTotal(total + 1)}
                                  disabled={
                                    getSingleProduct.quantity === 0 ||
                                    total >= getSingleProduct.quantity
                                  }
                                  className="flex items-center justify-center h-full flex-shrink-0 transition ease-in-out duration-300 focus:outline-none w-8 md:w-12 text-heading border-s border-gray-300 hover:text-gray-500"
                                >
                                  <span className="text-dark text-base">
                                    <svg
                                      stroke="currentColor"
                                      fill="none"
                                      strokeWidth="2"
                                      viewBox="0 0 24 24"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      height="1em"
                                      width="1em"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <line x1="12" y1="5" x2="12" y2="19"></line>
                                      <line x1="5" y1="12" x2="19" y2="12"></line>
                                    </svg>
                                  </span>
                                </button>
                              </div>

                              <button
                                disabled={getSingleProduct.quantity === 0}
                                onClick={() => handleAddToCart(getSingleProduct)}
                                className="text-sm leading-4 inline-flex items-center cursor-pointer transition ease-in-out duration-300 font-semibold text-center justify-center border-0 border-transparent rounded-md focus-visible:outline-none focus:outline-none text-white px-4 ml-4 md:px-6 lg:px-8 py-4 md:py-3.5 lg:py-4 hover:text-white bg-emerald-500 hover:bg-emerald-600 w-54 h-12"
                              >
                                {text.ButtonLabel}
                              </button>

                            </div>
                          </div>

                          <div className="flex flex-col mt-4">
                            <span className=" font-semibold py-1 text-sm d-block">
                              <span className="text-gray-700">Category: </span>
                              <span className="text-gray-500">
                                {language === 'en'
                                  ? getSingleProduct.parent_data.name
                                  : getSingleProduct.parent_data.name_hindi}
                              </span>
                            </span>
                            <div className="flex flex-row">{/* Tags if needed */}</div>
                            <SocialNetwork currentPageurl={currentPageurl} />
                          </div>
                        </div>
                      </div>
                      <Informations />
                    </div>
                  </div>
                </div>
                <div dangerouslySetInnerHTML={{ __html: getSingleProduct?.product_description }} />
              </div>
              {/* Related products commented out */}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
